import { AdminFinancialMonthlyPoint } from "./AdminFinancialMonthlyPoint"
import { AdminFinancialSummary } from "./AdminFinancialSummary"
import { AdminRestaurantFinancialMetric } from "./AdminRestaurantFinancialMetric"

export class AdminFinancialMetrics {
  summary: AdminFinancialSummary

  monthlySeries: AdminFinancialMonthlyPoint[]

  topRestaurants: AdminRestaurantFinancialMetric[]

  constructor(data: Partial<AdminFinancialMetrics> = {}) {
    this.summary = new AdminFinancialSummary(data.summary)

    this.monthlySeries = data.monthlySeries?.map((item) => new AdminFinancialMonthlyPoint(item)) ?? []

    this.topRestaurants = data.topRestaurants?.map((item) => new AdminRestaurantFinancialMetric(item)) ?? []
  }
}
